import { render, staticRenderFns } from "./HistorialUMERS.vue?vue&type=template&id=0d45c3b1&scoped=true"
import script from "./HistorialUMERS.vue?vue&type=script&lang=js"
export * from "./HistorialUMERS.vue?vue&type=script&lang=js"
import style0 from "./HistorialUMERS.vue?vue&type=style&index=0&id=0d45c3b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45c3b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d45c3b1')) {
      api.createRecord('0d45c3b1', component.options)
    } else {
      api.reload('0d45c3b1', component.options)
    }
    module.hot.accept("./HistorialUMERS.vue?vue&type=template&id=0d45c3b1&scoped=true", function () {
      api.rerender('0d45c3b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/components/HistorialUMERS.vue"
export default component.exports